var map = {
	"./007-microphone-1.png": "./src/static/img/icon/007-microphone-1.png",
	"./010-home.png": "./src/static/img/icon/010-home.png",
	"./013-document-1.png": "./src/static/img/icon/013-document-1.png",
	"./014-document.png": "./src/static/img/icon/014-document.png",
	"./015-color-palette.png": "./src/static/img/icon/015-color-palette.png",
	"./017-video-camera.png": "./src/static/img/icon/017-video-camera.png",
	"./024-like.svg": "./src/static/img/icon/024-like.svg",
	"./1.svg": "./src/static/img/icon/1.svg",
	"./155-credit-card.svg": "./src/static/img/icon/155-credit-card.svg",
	"./2.svg": "./src/static/img/icon/2.svg",
	"./3.svg": "./src/static/img/icon/3.svg",
	"./4.svg": "./src/static/img/icon/4.svg",
	"./New Customer.svg": "./src/static/img/icon/New Customer.svg",
	"./NotOpen.svg": "./src/static/img/icon/NotOpen.svg",
	"./Opened.svg": "./src/static/img/icon/Opened.svg",
	"./Profit.svg": "./src/static/img/icon/Profit.svg",
	"./SalesRevenue.svg": "./src/static/img/icon/SalesRevenue.svg",
	"./Sent.svg": "./src/static/img/icon/Sent.svg",
	"./Slack.svg": "./src/static/img/icon/Slack.svg",
	"./address.svg": "./src/static/img/icon/address.svg",
	"./adidas.svg": "./src/static/img/icon/adidas.svg",
	"./adobe.svg": "./src/static/img/icon/adobe.svg",
	"./arrow-growth.svg": "./src/static/img/icon/arrow-growth.svg",
	"./arrow-left.png": "./src/static/img/icon/arrow-left.png",
	"./arrow-left.svg": "./src/static/img/icon/arrow-left.svg",
	"./arrow-right.png": "./src/static/img/icon/arrow-right.png",
	"./arrow-right.svg": "./src/static/img/icon/arrow-right.svg",
	"./bell.svg": "./src/static/img/icon/bell.svg",
	"./book-open.svg": "./src/static/img/icon/book-open.svg",
	"./book.svg": "./src/static/img/icon/book.svg",
	"./briefcase.svg": "./src/static/img/icon/briefcase.svg",
	"./business.svg": "./src/static/img/icon/business.svg",
	"./camera.svg": "./src/static/img/icon/camera.svg",
	"./chat.svg": "./src/static/img/icon/chat.svg",
	"./check-circle.svg": "./src/static/img/icon/check-circle.svg",
	"./clipboard.svg": "./src/static/img/icon/clipboard.svg",
	"./clock.svg": "./src/static/img/icon/clock.svg",
	"./cloud.svg": "./src/static/img/icon/cloud.svg",
	"./columns.svg": "./src/static/img/icon/columns.svg",
	"./crop.svg": "./src/static/img/icon/crop.svg",
	"./documentation.svg": "./src/static/img/icon/documentation.svg",
	"./dollar-circle.svg": "./src/static/img/icon/dollar-circle.svg",
	"./envelope.svg": "./src/static/img/icon/envelope.svg",
	"./file.svg": "./src/static/img/icon/file.svg",
	"./flat.svg": "./src/static/img/icon/flat.svg",
	"./google-customIcon.svg": "./src/static/img/icon/google-customIcon.svg",
	"./google-plus.svg": "./src/static/img/icon/google-plus.svg",
	"./headphone.svg": "./src/static/img/icon/headphone.svg",
	"./heart-fill.svg": "./src/static/img/icon/heart-fill.svg",
	"./home.svg": "./src/static/img/icon/home.svg",
	"./iconfinder_trello_2317760.svg": "./src/static/img/icon/iconfinder_trello_2317760.svg",
	"./idea.svg": "./src/static/img/icon/idea.svg",
	"./image.png": "./src/static/img/icon/image.png",
	"./image.svg": "./src/static/img/icon/image.svg",
	"./label.png": "./src/static/img/icon/label.png",
	"./land (2).png": "./src/static/img/icon/land (2).png",
	"./land-icon.svg": "./src/static/img/icon/land-icon.svg",
	"./land.svg": "./src/static/img/icon/land.svg",
	"./layers.svg": "./src/static/img/icon/layers.svg",
	"./left-bar.svg": "./src/static/img/icon/left-bar.svg",
	"./left.svg": "./src/static/img/icon/left.svg",
	"./logo2.svg": "./src/static/img/icon/logo2.svg",
	"./logo3.svg": "./src/static/img/icon/logo3.svg",
	"./logo4.svg": "./src/static/img/icon/logo4.svg",
	"./logo5.svg": "./src/static/img/icon/logo5.svg",
	"./logo6.svg": "./src/static/img/icon/logo6.svg",
	"./logoIn.svg": "./src/static/img/icon/logoIn.svg",
	"./message.svg": "./src/static/img/icon/message.svg",
	"./microsoft.svg": "./src/static/img/icon/microsoft.svg",
	"./money-wave.svg": "./src/static/img/icon/money-wave.svg",
	"./nitrogen-icon.svg": "./src/static/img/icon/nitrogen-icon.svg",
	"./nitrogen.svg": "./src/static/img/icon/nitrogen.svg",
	"./paint.svg": "./src/static/img/icon/paint.svg",
	"./phosphorus.svg": "./src/static/img/icon/phosphorus.svg",
	"./potassium.svg": "./src/static/img/icon/potassium.svg",
	"./protection.svg": "./src/static/img/icon/protection.svg",
	"./quote-left.png": "./src/static/img/icon/quote-left.png",
	"./quote-right.png": "./src/static/img/icon/quote-right.png",
	"./quote.png": "./src/static/img/icon/quote.png",
	"./repeat.svg": "./src/static/img/icon/repeat.svg",
	"./right.svg": "./src/static/img/icon/right.svg",
	"./setting.svg": "./src/static/img/icon/setting.svg",
	"./shopping-cart.svg": "./src/static/img/icon/shopping-cart.svg",
	"./soil.svg": "./src/static/img/icon/soil.svg",
	"./speed-meter.svg": "./src/static/img/icon/speed-meter.svg",
	"./strategy.svg": "./src/static/img/icon/strategy.svg",
	"./theme.svg": "./src/static/img/icon/theme.svg",
	"./ticket.svg": "./src/static/img/icon/ticket.svg",
	"./user.svg": "./src/static/img/icon/user.svg",
	"./users-alt.svg": "./src/static/img/icon/users-alt.svg",
	"./water-drop.svg": "./src/static/img/icon/water-drop.svg",
	"./water-fall.svg": "./src/static/img/icon/water-fall.svg",
	"./wordpress.svg": "./src/static/img/icon/wordpress.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/static/img/icon sync recursive ^\\.\\/.*$";